import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { TrackedArray } from 'tracked-built-ins';
import { registerDestructor } from '@ember/destroyable';

export default class NotifyService extends Service {
  #workingOnIt = 0;
  @tracked workingOnIt = false;

  alerts = new TrackedArray([]);

  @action startWorkingOnIt() {
    this.workingOnIt = Boolean(++this.#workingOnIt);
  }

  @action stopWorkingOnIt() {
    if (this.#workingOnIt > 0) {
      this.workingOnIt = Boolean(--this.#workingOnIt);
    }
  }

  @action alert(message, error) {
    if (error) {
      console.error(message, error);
    }

    const alert = { message, error };
    this.alerts.push(alert);

    const timeout = setTimeout(
      () => this.clearAlert(alert),
      error ? 5000 : 3000,
    );
    registerDestructor(this, () => clearTimeout(timeout));
  }

  @action clearAlert(alert) {
    const index = this.alerts.findIndex((x) => x === alert);
    if (index >= 0) {
      this.alerts.splice(index, 1);
    }
  }

  @action clearAlerts() {
    this.alerts.length = 0;
  }
}
